import { render, staticRenderFns } from "./EventDetail.vue?vue&type=template&id=22969676&"
import script from "./EventDetail.controller.js?vue&type=script&lang=js&"
export * from "./EventDetail.controller.js?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./EventDetail.styles.scss?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "ac9d2ce6"
  
)

export default component.exports